import React from "react";
import { MainH1, MainText, RegBtn, RegCont } from "./HuddleStyleComp";

const Register = () => {
  return (
    <RegCont>
      <MainH1>Build The Community Your Fans Will Love</MainH1>
      <MainText>
        Huddle re-imagines the way we build communities. You have a voice, but
        so does your audience. Create connections with your users as you engage
        in genuine discussion.
      </MainText>
      <RegBtn>Register</RegBtn>
    </RegCont>
  );
};

export default Register;
